import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStackedBarChart2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="stacked-bar-chart-2, revenue"><path d="M19.25 4C20.2165 4 21 4.7835 21 5.75V18.5H21.25C21.6642 18.5 22 18.8358 22 19.25C22 19.6642 21.6642 20 21.25 20H2.75C2.33579 20 2 19.6642 2 19.25C2 18.8358 2.33579 18.5 2.75 18.5H3V12.75C3 11.7835 3.7835 11 4.75 11C5.7165 11 6.5 11.7835 6.5 12.75V18.5H7.5V7.75C7.5 6.7835 8.2835 6 9.25 6C10.2165 6 11 6.7835 11 7.75V18.5H13V10.75C13 9.7835 13.7835 9 14.75 9C15.7165 9 16.5 9.7835 16.5 10.75V18.5H17.5V5.75C17.5 4.7835 18.2835 4 19.25 4Z" fill="currentColor"/></CentralIconBase>;
};

export default IconStackedBarChart2;
